module.exports = __webpack_public_path__ + "img/i_homework-upload.ee8c67e8.svg";